import { useCallback, useEffect, useState } from "react";

const useContextMenu = ({ shouldOpen }) => {
  const [contextMenu, setContextMenu] = useState({
    visible: false,
    x: 0,
    y: 0,
    type: null,
    data: null,
  });

  const openContextMenu = useCallback((x, y, payload = {}) => {
    setContextMenu({
      visible: true,
      x,
      y,
      type: payload.type || "empty",
      data: payload.data || null,
    });
  }, []);

  const closeContextMenu = useCallback(() => {
    setContextMenu({
      visible: false,
      x: 0,
      y: 0,
      type: null,
      data: null,
    });
  }, []);

  useEffect(() => {
    const handleContextMenu = (e) => {
      const playerEl = e.target.closest("[data-player-id]");
      const tableEl = e.target.closest("[data-table-id]");

      if (!shouldOpen()) return;

      e.preventDefault();

      if (playerEl) {
        openContextMenu(e.clientX, e.clientY, {
          type: "player",
          data: {
            playerId: playerEl.getAttribute("data-player-id"),
            playerKind: playerEl.getAttribute("data-player-kind") || "user",
            tableId: playerEl.getAttribute("data-table-id"),
          },
        });
      } else if (tableEl) {
        openContextMenu(e.clientX, e.clientY, {
          type: "empty",
          data: {
            tableId: tableEl.getAttribute("data-table-id"),
          },
        });
      }
    };

    const handleClick = () => {
      closeContextMenu();
    };

    window.addEventListener("contextmenu", handleContextMenu);
    window.addEventListener("click", handleClick);
    return () => {
      window.removeEventListener("contextmenu", handleContextMenu);
      window.removeEventListener("click", handleClick);
    };
  }, [shouldOpen, openContextMenu, closeContextMenu]);

  return { contextMenu, openContextMenu, closeContextMenu };
};

export default useContextMenu;
